import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-between space-x-2 tw"
};
const _hoisted_2 = {
  class: "w-1/2"
};
const _hoisted_3 = {
  class: "w-6/12"
};
const _hoisted_4 = {
  class: "w-full flex gap-2"
};
const _hoisted_5 = {
  key: 0,
  class: "space-x-2 mt-2 tw"
};
const _hoisted_6 = {
  class: "w-full mt-4",
  "data-cy": "time-description-div"
};
const _hoisted_7 = {
  class: "w-full mt-4"
};
const _hoisted_8 = {
  class: "w-full flex mt-2"
};
const _hoisted_9 = {
  class: "w-6/12"
};
const _hoisted_10 = {
  class: "w-1/2"
};
const _hoisted_11 = {
  key: 1,
  class: "w-full mt-2"
};
const _hoisted_12 = {
  key: 2,
  class: "w-full mt-2"
};
const _hoisted_13 = {
  class: "w-full"
};
const _hoisted_14 = {
  class: "w-1/2",
  "data-replay-unmask": ""
};
const _hoisted_15 = {
  key: 3,
  class: "w-full mt-2"
};
import { onMounted, reactive, computed, ref } from 'vue';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { storeToRefs } from 'pinia';
import LlSelect from '@/components/LlSelect.vue';
import SelectUser from '@/components/SelectUser.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import BillableTypePicker from '@/components/BillableTypePicker.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import CodePicker from '@/components/CodePicker.vue';
import RateAdjustOptions from './RateAdjustOptions.vue';
import DescriptionInput from '@/components/DescriptionInput.vue';
import InternalNotesToggle from '@/components/InternalNotesToggle.vue';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCodeStore } from '@/services/useCodeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import LlDoubleSwitch from '@/components/LlDoubleSwitch.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import StartEndTime from './StartEndTime.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import ListsService from '@/services/ListsService';
import { useChargesStore } from '@/services/UserService/useChargesStore';
import { useRateGroupLogic } from '@/composables/useRateGroupLogic';
import { useBlockBilling } from '@/composables/useBlockBilling';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import useClientMatterStore from '@/services/useClientMatterStore';
import { mod } from '@/services/utils';
import { useEntryInitStore } from '@/services/useEntryInitStore';
import { useTimeEntryDates } from '@/composables/useTimeEntryDates';
import { extractDate, extractTime } from '@/utils/dateTimeUtils';
export default {
  __name: 'NewTimeEntry',
  props: {
    entryEditService: {
      type: Object,
      required: true
    },
    snippetService: {
      type: Object,
      required: true
    }
  },
  emits: ['confirm', 'cancel'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      normalizeTimeToHHMM,
      convertTimeStringToDate,
      createStartEndTimes,
      handleCrossDayEntry,
      validateTimeEntry
    } = useTimeEntryDates();
    const props = __props;
    const emit = __emit;
    const invoiceState = useInvoiceState();
    const invoiceEditorStore = useInvoiceEditorStore();
    const codeStore = useCodeStore();
    const meStore = useMeStore();
    const {
      permissions
    } = storeToRefs(useMeStore());
    const {
      selectedLineItem,
      process
    } = invoiceEditorStore;
    const {
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const listsService = new ListsService();
    const {
      handleError
    } = useSnackbarHandler();
    const {
      listCharges
    } = useChargesStore();
    const {
      listAccounts
    } = useAccountsStore();
    const {
      shouldFetchMatterDetails,
      fetchMatterDetailsIfNeeded,
      getRateListWithSelection
    } = useRateGroupLogic();
    const {
      getMatterByIdForEntryDropdown
    } = useClientMatterStore();
    const {
      setOriginalValues
    } = useBlockBilling();
    const entryInitStore = useEntryInitStore();
    const {
      companySettings
    } = storeToRefs(useCompanyStore());

    // Helper function to get the current matter ID for filtering users
    const newTimeEntryModalState = reactive({
      me: {},
      fixedFeeList: [],
      showMatterDropdown: false,
      rateList: [],
      allAccounts: [],
      // Store full account data with Standard rates
      matterDetail: null,
      // Store complete matter details with users array, like EditEntry.vue
      form: {
        id: null,
        clientId: '',
        matterId: '',
        date: new Date(),
        amount: 0,
        hours: companySettings.value?.timeEntryIncrement || 0.1,
        // Set default to time entry increment
        billedHours: 0,
        account: {},
        description: '',
        customFlag: false,
        rate: {
          label: 'Standard',
          amount: 0
        },
        charge: undefined,
        chargeId: undefined,
        entryBillingTypes: [],
        startTime: new Date(),
        endTime: new Date(),
        codes: {
          activity: {
            id: null
          },
          task: {
            id: null
          }
        }
      },
      loaded: false,
      showRemoveLineModal: false,
      startEndMode: false,
      advancedMode: false,
      showErrors: false
    });
    onMounted(async () => {
      try {
        await codeStore.activityCodes();
        await codeStore.taskCodes();

        // Fetch all accounts with their Standard rates (like EditEntry.vue does)
        newTimeEntryModalState.allAccounts = await listAccounts();

        // Initialize step with company settings
        const localDefaultStep = companySettings.value.timeEntryIncrement || 0.1;
        entryInitStore.updateStep(localDefaultStep);
        newTimeEntryModalState.form = JSON.parse(JSON.stringify(selectedLineItem.entries[0]));

        // Set default hours to the company's time entry increment
        newTimeEntryModalState.form.hours = localDefaultStep;

        // Convert times to HH:MM format using the composable
        newTimeEntryModalState.form.startTime = normalizeTimeToHHMM(newTimeEntryModalState.form.startTime, new Date());

        // Set end time to one hour after start by default
        const endDate = new Date();
        endDate.setHours(endDate.getHours() + 1);
        newTimeEntryModalState.form.endTime = normalizeTimeToHHMM(newTimeEntryModalState.form.endTime, endDate);
        if (invoiceState.ledes && !newTimeEntryModalState.form.codes) {
          newTimeEntryModalState.form.codes = {
            activity: {
              id: null
            },
            task: {
              id: null
            }
          };
        }
        newTimeEntryModalState.me = meStore.me;

        // Note: User fetching is now handled by the SelectUser component
        // No need to manually fetch availableAccounts here

        // Find the current account in whatever users are available (handled by SelectUser)
        if (newTimeEntryModalState.form.account?.id) {
          // SelectUser component will handle ensuring the current account is available
          // even if it's not in the matter-assigned users list
        }
        await fetchMatterUsers();
        getRateList();
        // Note: Removed the logic that merges accounts from lineItems as we want to restrict
        // to only matter-assigned users per the requirements
        await getCharges();
        newTimeEntryModalState.entryBillingTypes = listsService.entryBillingTypes;
        newTimeEntryModalState.form.billingType = newTimeEntryModalState.entryBillingTypes.find(x => x.id === newTimeEntryModalState.form.billingType.id);
        newTimeEntryModalState.loaded = true;

        // Store original values when component mounts using the composable
        setOriginalValues(newTimeEntryModalState.form.description || '', newTimeEntryModalState.form.hours || 0);

        // Enhanced entryEditService with better error handling
        setupEntryEditService();
      } catch (error) {
        console.error('Error in NewTimeEntry onMounted:', error);
        handleError('Failed to initialize new time entry form');
      }
    });
    const setupEntryEditService = () => {
      // Ensure the entryEditService has the updateHours method for StartEndTime component
      if (props.entryEditService && !props.entryEditService.updateHours) {
        props.entryEditService.updateHours = form => {
          try {
            // Comprehensive validation
            if (!form || typeof form !== 'object') {
              console.error('updateHours: Invalid form object');
              return;
            }
            if (!form.startTime || !form.endTime) {
              return;
            }

            // Convert time strings to Date objects for calculation
            const baseDate = new Date(form.date);
            const startTime = convertTimeStringToDate(form.startTime, baseDate);
            const endTime = convertTimeStringToDate(form.endTime, baseDate);
            if (!startTime || !endTime) {
              console.warn('updateHours: Failed to convert time strings to dates');
              return;
            }

            // Calculate actual hours difference
            let actualEndTime = endTime;

            // If end time is before start time, assume it's next day
            if (endTime < startTime) {
              actualEndTime = new Date(endTime);
              actualEndTime.setDate(actualEndTime.getDate() + 1);
            }

            // Calculate hours difference
            const diffMs = actualEndTime.getTime() - startTime.getTime();
            const diffHours = diffMs / (1000 * 60 * 60);

            // Validate reasonable duration
            if (diffHours < 0 || diffHours > 24) {
              console.warn('updateHours: Invalid duration calculated:', diffHours);
              return;
            }

            // Apply rounding based on company increment
            const increment = companySettings.value.timeEntryIncrement || 0.1;
            const roundedHours = Math.round(diffHours / increment) * increment;
            const finalHours = Math.max(increment, parseFloat(roundedHours.toFixed(2)));

            // Avoid unnecessary updates
            if (!isNaN(form.hours) && Math.abs(form.hours - finalHours) < 0.001) {
              return;
            }

            // Update the form hours directly
            form.hours = finalHours;

            // Also update the reactive state to ensure Vue reactivity
            if (newTimeEntryModalState?.form && newTimeEntryModalState.form === form) {
              newTimeEntryModalState.form.hours = finalHours;
            }
          } catch (error) {
            console.error('Error in updateHours:', error);
          }
        };
      }

      // Add updateEndTime method with proper error handling
      if (props.entryEditService && !props.entryEditService.updateEndTime) {
        props.entryEditService.updateEndTime = form => {
          try {
            // For NewTimeEntry, we don't need to update end time when start time changes
            // because we calculate hours directly and the end time stays as the user entered it
            return;
          } catch (error) {
            console.error('Error in updateEndTime:', error);
          }
        };
      }

      // Add getStep method validation
      if (props.entryEditService && !props.entryEditService.getStep) {
        props.entryEditService.getStep = () => {
          return companySettings.value.timeEntryIncrement || 0.1;
        };
      }
    };
    const fetchMatterUsers = async () => {
      const matterId = getMatterId();
      if (matterId) {
        // Use the same endpoint as EditEntry.vue to get complete matter details with users array
        // This ensures matter-specific custom rates are available when Rate Groups are disabled
        newTimeEntryModalState.matterDetail = await getMatterByIdForEntryDropdown(matterId, true);
        // Also update invoiceState for compatibility with existing Draft Editor logic
        if (shouldFetchMatterDetails(invoiceState)) {
          await fetchMatterDetailsIfNeeded(matterId, invoiceState, handleError);
        }
      }
    };
    const getMatterId = () => {
      // Use the centralized logic with form matterId
      return invoiceState.getCurrentMatterId(newTimeEntryModalState.form.matterId);
    };
    const getCharges = async () => {
      const matterId = getMatterId();
      newTimeEntryModalState.fixedFeeList = await listCharges({
        matterId,
        acceptsTime: true
      });
    };
    const switchTimeMode = value => {
      newTimeEntryModalState.startEndMode = value;
    };
    const customFlagLabel = computed(() => {
      return companySettings.value.labels?.customFlag || null;
    });
    const handleDateChange = () => {
      // When the date changes, update times more efficiently
      if (!newTimeEntryModalState.startEndMode || !newTimeEntryModalState.form.date) {
        return;
      }
      try {
        const newDate = new Date(newTimeEntryModalState.form.date);

        // Keep the time portions, just update the date
        if (typeof newTimeEntryModalState.form.startTime === 'string') {
          newTimeEntryModalState.form.startTime = normalizeTimeToHHMM(convertTimeStringToDate(newTimeEntryModalState.form.startTime, newDate), newDate);
        }
        if (typeof newTimeEntryModalState.form.endTime === 'string') {
          newTimeEntryModalState.form.endTime = normalizeTimeToHHMM(convertTimeStringToDate(newTimeEntryModalState.form.endTime, newDate), newDate);
        }
      } catch (error) {
        handleError('Error updating times for new date');
        console.error('Date change error:', error);
      }
    };
    const handleAccountChange = () => {
      // Clear the existing rate when timekeeper changes to force recalculation
      newTimeEntryModalState.form.rate = null;
      getRateList(true); // Pass isUserChange=true
    };
    const handleCodeChange = event => {
      newTimeEntryModalState.form.codes = event;
    };
    const getRateList = (isUserChange = false) => {
      // Use matterDetail from NewTimeEntry state (like EditEntry.vue does) 
      // Fall back to invoiceState.matter for compatibility
      const matter = newTimeEntryModalState.matterDetail || invoiceState.matter || (invoiceState.matters && invoiceState.matters.length > 0 ? invoiceState.matters[0] : null);
      let account = newTimeEntryModalState.form.account;

      // Validation check like EditEntry.vue: ensure we have both matter and account before proceeding
      if (!matter || !account) {
        newTimeEntryModalState.rateList = [];
        return;
      }

      // Draft Editor: account object doesn't have rates property
      // We need to use the full account data from allAccounts to get the complete rates structure
      if (account && !account.rates) {
        // Find the full account data with complete rates structure (standard, other, etc.)
        const fullAccount = newTimeEntryModalState.allAccounts?.find(a => a.id === account.id);
        if (fullAccount?.rates) {
          // Use the full account object with its complete rates structure
          // This ensures we get the exact same rate structure as EditEntry.vue
          account = fullAccount;
        }
      }

      // Now using the same parameters as EditEntry.vue adjustRateToSelection function
      const {
        rateList,
        selectedRate
      } = getRateListWithSelection(account, matter, false,
      // isExistingEntry - always false for new entries
      newTimeEntryModalState.form,
      // existingForm
      !isUserChange,
      // isMatterChange - true for initial load, false for user changes
      isUserChange,
      // isUserChange - true when timekeeper changes
      false,
      // isDuplicate
      null,
      // originalEntry
      false // matterChangedDuringSession
      );
      newTimeEntryModalState.rateList = rateList;
      if (selectedRate) {
        newTimeEntryModalState.form.rate = selectedRate;
      }
    };
    const handleRateChangeUpdate = updatedForm => {
      if (newTimeEntryModalState.form.rate !== updatedForm.rate) {
        newTimeEntryModalState.form.rate = updatedForm.rate;
      }
    };
    const createEntry = async () => {
      try {
        if (createDisabled.value) {
          newTimeEntryModalState.showErrors = true;
          let message = newTimeEntryModalState.form.account === null ? 'User is required.' : '';
          message += newTimeEntryModalState.form.description.length === 0 ? ' Description is required. ' : '';
          handleError(message);
          return;
        }
        if (newTimeEntryModalState.form.hours <= 0) {
          handleError('Hours must be greater than zero');
          return;
        }
        if (newTimeEntryModalState.form.rate?.amount && newTimeEntryModalState.form.rate?.amount <= 0) {
          handleError('Amount cannot be negative');
          return;
        }
        const increment = parseFloat(companySettings.value.timeEntryIncrement || 0.1);
        if (companySettings.value.enforceRounding && mod(newTimeEntryModalState.form.hours, increment) !== 0) {
          handleError(`Your firm has Enforced Rounding enabled. Your Hours must be an increment of ${increment}.`);
          return;
        }
        const entryData = {
          ...newTimeEntryModalState.form
        };
        const baseDate = new Date(entryData.date);
        if (newTimeEntryModalState.startEndMode) {
          entryData.startTime = convertTimeStringToDate(entryData.startTime, baseDate);
          entryData.endTime = convertTimeStringToDate(entryData.endTime, baseDate);
          if (!entryData.startTime || !entryData.endTime) {
            handleError('Invalid start or end time format');
            return;
          }

          // Correctly destructure all returned properties
          const {
            startTime: adjustedStartTime,
            endTime: adjustedEndTime,
            crossesDay
          } = handleCrossDayEntry(entryData.startTime, entryData.endTime);
          entryData.startTime = adjustedStartTime;
          entryData.endTime = adjustedEndTime;
          const validation = validateTimeEntry(entryData.startTime, entryData.endTime);
          if (!validation.isValid) {
            handleError(validation.error);
            return;
          }
        } else {
          const {
            startTime,
            endTime
          } = createStartEndTimes(entryData.hours, baseDate);
          entryData.startTime = startTime;
          entryData.endTime = endTime;
        }

        // Transform charge object to chargeId for fixed fee entries
        if (entryData.charge?.id) {
          entryData.chargeId = entryData.charge.id;
        }
        // Always remove the charge object from the payload to avoid sending it to the API
        delete entryData.charge;

        // NEW: Send localDateTime format for backend (Story #25310)
        // Backend will handle timezone conversion using user's timezone setting
        // TODO (Story #25310): Remove legacy startTime/endTime after migration complete
        entryData.localDateTime = {
          date: extractDate(entryData.date),
          time: extractTime(entryData.startTime)
        };
        newTimeEntryModalState.loaded = false;
        await invoiceEditorStore.saveNewEntry(entryData);
        newTimeEntryModalState.loaded = true;
        emit('confirm');
      } catch (error) {
        newTimeEntryModalState.loaded = true;
        handleError('Failed to create time entry: ' + error.message);
        console.error('Create entry error:', error);
      }
    };
    const handleHoursChange = () => {
      try {
        // Use the entryEditService to update step, similar to EditEntry.vue
        if (newTimeEntryModalState.form.hours && props.entryEditService?.updateStepFromEntry) {
          props.entryEditService.updateStepFromEntry(newTimeEntryModalState.form);
        }
      } catch (error) {
        console.error('Error in handleHoursChange:', error);
      }
    };
    const handleHoursCalculated = calculatedHours => {
      try {
        if (typeof calculatedHours === 'number' && calculatedHours > 0) {
          newTimeEntryModalState.form.hours = calculatedHours;
          // Use the entryEditService to update step - this is handled by the composable
          // but we keep this for consistency
          if (props.entryEditService?.updateStepFromEntry) {
            props.entryEditService.updateStepFromEntry(newTimeEntryModalState.form);
          }
        } else {
          console.warn('Invalid calculated hours value:', calculatedHours);
        }
      } catch (error) {
        console.error('Error in handleHoursCalculated:', error);
      }
    };
    const createDisabled = computed(() => {
      return newTimeEntryModalState.form.account?.id === null || newTimeEntryModalState.form.description.length === 0;
    });

    // Expose methods for testing
    __expose({
      handleHoursChange,
      handleHoursCalculated,
      newTimeEntryModalState
    });
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, null, {
        prepend: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("New Time Entry", -1)]))]),
          _: 1
        })]),
        append: _withCtx(() => [_createVNode(LlDoubleSwitch, {
          "model-value": newTimeEntryModalState.advancedMode,
          "left-label": "Standard",
          "right-label": "Advanced",
          "data-cy": "standard-advanced-switch",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => newTimeEntryModalState.advancedMode = $event)
        }, null, 8, ["model-value"]), _createVNode(LlSecondaryButton, {
          icon: "mdi-close",
          variant: "text",
          size: "small",
          "aria-label": "Close new time entry",
          onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('cancel'))
        })]),
        default: _withCtx(() => [newTimeEntryModalState.loaded ? (_openBlock(), _createBlock(_component_v_card_text, {
          key: 0
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(SelectUser, {
            modelValue: newTimeEntryModalState.form.account,
            "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => newTimeEntryModalState.form.account = $event), handleAccountChange],
            disabled: _unref(onlyViewInvoice) || !_unref(permissions)?.billing?.edit,
            "use-matter-filtering": true,
            "matter-id": _unref(invoiceState).getCurrentMatterId(newTimeEntryModalState.form.matterId)
          }, null, 8, ["modelValue", "disabled", "matter-id"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(LlDatePicker, {
            class: "inline-block h-full w-full",
            modelValue: newTimeEntryModalState.form.date,
            "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => newTimeEntryModalState.form.date = $event), _cache[4] || (_cache[4] = $event => handleDateChange())]
          }, null, 8, ["modelValue"])])])]), _unref(invoiceState).ledes && newTimeEntryModalState.loaded ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(CodePicker, {
            form: newTimeEntryModalState.form,
            disabled: _unref(onlyViewInvoice) || !_unref(permissions)?.billing?.edit,
            okToClearDescription: true,
            onCodeChange: handleCodeChange,
            "data-cy": "new-time-entry-code-picker"
          }, null, 8, ["form", "disabled"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createVNode(DescriptionInput, {
            form: newTimeEntryModalState.form,
            "snippet-service": __props.snippetService,
            "edit-entry-state": null,
            "enable-block-billing": true,
            onHoursCalculated: handleHoursCalculated
          }, null, 8, ["form", "snippet-service"])]), _createVNode(InternalNotesToggle, {
            modelValue: newTimeEntryModalState.form.notes,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => newTimeEntryModalState.form.notes = $event)
          }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_7, [_createVNode(BillableTypePicker, {
            form: newTimeEntryModalState.form,
            fixedFeeList: newTimeEntryModalState.fixedFeeList,
            entryBillingTypes: newTimeEntryModalState.entryBillingTypes,
            isFromDraft: !!_unref(invoiceEditorStore)?.selectedGroup,
            groupType: _unref(invoiceEditorStore)?.selectedGroup?.type,
            "data-cy": "billing-type-dropdown",
            "onUpdate:form": _cache[6] || (_cache[6] = updatedForm => newTimeEntryModalState.form = updatedForm)
          }, null, 8, ["form", "fixedFeeList", "entryBillingTypes", "isFromDraft", "groupType"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [customFlagLabel.value ? (_openBlock(), _createBlock(LlCheckbox, {
            key: 0,
            modelValue: newTimeEntryModalState.form.customFlag,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => newTimeEntryModalState.form.customFlag = $event),
            label: customFlagLabel.value
          }, null, 8, ["modelValue", "label"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_createVNode(LlDoubleSwitch, {
            "model-value": newTimeEntryModalState.startEndMode,
            "left-label": "Hours",
            "right-label": "Start/End",
            "data-cy": "hours-start-end-switch",
            "onUpdate:modelValue": switchTimeMode
          }, null, 8, ["model-value"])])]), newTimeEntryModalState.startEndMode ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(StartEndTime, {
            form: newTimeEntryModalState.form,
            entryEditService: props.entryEditService,
            editEntryState: {
              lockCalculatingHoursFromDescription: false
            },
            adjustments: false,
            showStartStopTime: true
          }, null, 8, ["form", "entryEditService"])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[12] || (_cache[12] = _createElementVNode("label", {
            class: "w-full"
          }, "Hours", -1)), _createElementVNode("div", _hoisted_14, [_createVNode(LlTextField, {
            type: "number",
            modelValue: newTimeEntryModalState.form.hours,
            "onUpdate:modelValue": [_cache[8] || (_cache[8] = $event => newTimeEntryModalState.form.hours = $event), _cache[9] || (_cache[9] = $event => handleHoursChange())],
            step: props.entryEditService.getStep(),
            min: 0,
            rules: [() => !!newTimeEntryModalState.form.hours || 'This field is required', () => newTimeEntryModalState.form.hours >= 0 || 'Must be greater than 0']
          }, null, 8, ["modelValue", "step", "rules"])]), _cache[13] || (_cache[13] = _createElementVNode("div", {
            class: "w-1/2"
          }, null, -1))])])), newTimeEntryModalState.advancedMode ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(RateAdjustOptions, {
            isModal: true,
            form: newTimeEntryModalState.form,
            rateList: newTimeEntryModalState.rateList,
            showAdjustRateText: false,
            "onUpdate:form": handleRateChangeUpdate,
            onAdjustRateToSelection: getRateList
          }, null, 8, ["form", "rateList"])])) : _createCommentVNode("", true)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_v_card_text, {
          key: 1
        }, {
          default: _withCtx(() => [_createVNode(_component_v_skeleton_loader, {
            type: "heading, heading, image, heading, image, heading, heading"
          })]),
          _: 1
        })), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(LlSecondaryButton, {
            color: "primary",
            class: "w-1/2 center",
            "data-cy": "create-entry",
            onClick: _cache[10] || (_cache[10] = $event => createEntry())
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" Create Entry ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};